import React, { useCallback, useMemo } from 'react';
import { ControlProps } from '@jsonforms/core';
import { TextField } from '@mui/material';
import { withJsonFormsControlProps } from '@jsonforms/react';
import './NumberControl.styles.scss';

/**
 * Plain number control (no use_endpoint). For number fields with use_endpoint, UseEndpointNumberControl is used instead.
 */
export const NumberControl = withJsonFormsControlProps((props: ControlProps) => {
    const { data, handleChange, path, label, required, errors, schema } = props;

    const showError = Array.isArray(errors) ? errors.length > 0 : Boolean(errors);

    const handleChangeEvent = useCallback(
        (e: React.ChangeEvent<HTMLInputElement>) => {
            const value = e.target.value;
            handleChange(path, value === '' ? '' : Number(value));
        },
        [handleChange, path]
    );

    const slotProps = useMemo(
        () => ({
            input: {
                step: schema?.type === 'number' ? 0.1 : 1,
                required: false,
            },
        }),
        [schema?.type]
    );

    return (
        <div className="rpc-number-control">
            <TextField
                type="number"
                value={data ?? ''}
                onChange={handleChangeEvent}
                label={label}
                required={required}
                error={showError}
                helperText={errors as React.ReactNode}
                variant="outlined"
                fullWidth
                slotProps={slotProps}
            />
        </div>
    );
});
